
const About = () => {

    return <>
        <h3>What, Where, and When</h3>
        <p>A <a href="https://www.fresnostate.edu/" className="about">CSU, Fresno</a> <a href="https://csm.fresnostate.edu/csci/index.html" className="about">Computer Science Program</a> project from Professor Athanasios Aris (Thanos) Panagopoulos' Spring 2022 Bio-Inspired Machine Learning course (CSCI 191T).</p>
        <h3>Group Members</h3>
        <ul>
            <li>Leon Kantikov</li>
            <li>Alexis Lara-Umana</li>
            <li>Vi Nguyen</li>
            <li>Michael Nugent</li>
        </ul>
        <h3>Programming Tools</h3>
        <p>Built with <a href="https://reactjs.org/" className="about">React</a> and hosted on <a href="https://firebase.google.com/" className="about">FireBase</a></p>
        <h3>Github Repository</h3>
        <p><a href="https://github.com/nugentmichael1/n-queens" className="about">https://github.com/nugentmichael1/n-queens</a></p>
    </>
};

export default About